import zhTW from './i18n/zh-tw.json';
import koKR from './i18n/kr.json';
import jaJP from './i18n/jp.json';
import enUS from './i18n/en.json';
import thTH from './i18n/th.json';
import I18n from 'i18n-js';
class LocaleClass {
	constructor(){
		this._eventHandlers = new Map();
	
		const i18nJSON = {
			'zh-tw': zhTW,
			'kr': koKR,
			'jp': jaJP,
			'en': enUS,
			'th': thTH
		};
		I18n.translations = i18nJSON;
		I18n.fallbacks = false;
		const defaultLang = 'zh-tw';
		I18n.missingTranslation = function (key) {
			const str = i18nJSON[defaultLang][key];
			return str ? str : key;
		};
		I18n.locale = 'zh-tw';
	}
	addEventListener(type, handler){
		this._eventHandlers.has(type) || this._eventHandlers.set(type, []);
		this._eventHandlers.get(type).push(handler);
	}
	removeEventListener(type, handler){
		if (!this._eventHandlers[type].has(handler)) {
			return;
		}
		this._eventHandlers[type].get(handler).remove();
		this._eventHandlers[type].delete(handler);
	}
	emit(type, ...args){
		let listeners = this._eventHandlers.get(type);
		if (listeners && listeners.length) {
			listeners.forEach((listener) => {
				listener(...args); 
			});
			return true;
		}
		return false;
	}
	get(){
		return I18n.locale;
	}
	set(nextLocale){
		I18n.locale = nextLocale;
		// onChangeLang(nextLocale);
		// this._eventHandlers['change'](nextLocale);
		this.emit('change');
	}
} 
export const Locale = new LocaleClass();

// export default (key, opts = {})=>{
//   return I18n.t(key, opts);
// };


export const i18n = (key, opts = {})=>{
	return I18n.t(key, opts);
};

export const getLocale = ()=>{
	return I18n.locale;
};

export const setLocale = (nextLocale)=>{
	I18n.locale = nextLocale;
};